import LoginLayout from './LoginLayout';
import { useState, useEffect } from 'react';
import lodash from 'lodash';

import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import {
    setResetPasswordAnswerError,
    setResetPasswordValidationError,
    fetchRegisterData,
    getRegistrationDetails,
    getallChallengeQuestions
} from '../../actions/login';
import styles from './Login.scss';
import PasswordValidation from './PasswordValidation';
import { Spinner } from '../../../components/common/LoadingStatus/LoadingStatus';
import { checkValidPassword } from './CheckValidPassword';

const NewUser = (props) => {
    const {
        setResetPasswordAnswerError,
        setResetPasswordValidationError,
        setChallengeQuestionAnswer,
        setRegistrationPassword
    } = props;

    const [answer, setAnswer] = useState('');
    const [password, setPassword] = useState('');
    const [passwordType, setPasswordType] = useState(true);
    const [showResetPassword, setShowResetPassword] = useState(false);
    const [validPassword, setValidPassword] = useState(false);
    const [invalidUrlError, setInvalidURlError] = useState('');
    const [allChallengeQuestions, setAllChallengeQuestions] = useState();
    const [selectedQuestion, setSelectedQuestion] = useState('');
    const [registrationEmail, setRegistrationEmail] = useState('');
    const [sessionDetails, setSessionDetails] = useState();
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const fullUrl = window.location.href;
                const url = new URL(fullUrl);
                const params = new URLSearchParams(url.search);

                const nonce = params.get('nonce');
                const email = params.get('email');

                if (nonce && email) {
                    const decodedEmail = decodeURIComponent(email);
                    const formattedEmail = decodedEmail.toLowerCase();
                    setRegistrationEmail(formattedEmail);

                    const registerData = await fetchRegisterData(nonce, email);
                    // eslint-disable-next-line no-useless-escape
                    const registerUrl = registerData.replace(/^https?:\/\/[^\/]+\//, '') + '&api=true';
                    const registrationDetails = await getRegistrationDetails(registerUrl);
                    setSessionDetails(registrationDetails);

                    const challengeQuestions = await getallChallengeQuestions(`setChallengeQuestion?nonce=${registrationDetails.nonce}&session=${registrationDetails.session}&api=true`);
                    if (challengeQuestions.message === 'redirect to set password') {
                        setShowResetPassword(true);
                        return;
                    }
                    if (challengeQuestions.message === 'redirect to set question') {
                        setAllChallengeQuestions(challengeQuestions.challengeQuestions);
                        setSelectedQuestion(challengeQuestions.challengeQuestions[0].question);
                        return;
                    }

                }
            }
            catch (e) {
                setInvalidURlError('Something went wrong, please try again !');
            }
            finally {
                setLoading(false);
            }

        };

        fetchData();
    }, []);



    const onSubmitClick = async (e) => {

        try {
            e.preventDefault();

            if (!showResetPassword && answer === '') {
                setResetPasswordAnswerError('Please enter your answer.');
                return;
            }

            if (!showResetPassword) {
                const params = {
                    nonce: sessionDetails.nonce,
                    email: registrationEmail,
                    sessionId: sessionDetails.session,
                    challengeQuestionId: allChallengeQuestions.find(q => q.question === selectedQuestion).id,
                    challengeQuestionAnswer: answer,
                };
                const response = await setChallengeQuestionAnswer(e, params);
                if (response.error) {
                    setResetPasswordAnswerError(response.error);
                    return;
                }
            }
            if (!showResetPassword) {
                setShowResetPassword(true);
                return;
            }
            if (password === '') {
                setResetPasswordValidationError('Please enter your new password.');
                return;
            }
            if (!validPassword || !checkValidPassword(password)) {
                setResetPasswordValidationError('Your password does not meet our requirements.');
                return;
            }
            if (validPassword) {
                setValidPassword(false);

                const registrationPasswordParams = {
                    nonce: sessionDetails.nonce,
                    sessionId: sessionDetails.session,
                    email: registrationEmail,
                    password: password,
                };
                await setRegistrationPassword(e, registrationPasswordParams);
            }
        }
        catch (e) {
            setInvalidURlError('Something went wrong, please try again !');
        }


    };
    const handleQuestionChange = (event) => {
        setSelectedQuestion(event.target.value);
    };

    const togglePasswordVisibility = () => {
        setPasswordType(!passwordType);
    };

    if (loading) {
        return (
            <div className={styles.Loader}>
                <Spinner actionLabel={'Loading'} itemName={''} />
            </div>
        );
    }

    return (
        <LoginLayout>
            {invalidUrlError === '' ?
                <div className={styles.complionTitle}>
                    {!showResetPassword ? 'Welcome!' : 'Create Password'}
                    {!showResetPassword && <div className={styles.caption}>
                        Please create your new account.
                    </div>}
                    {showResetPassword && <div className={styles.caption}>
                        Please set your new password.
                    </div>}
                </div> : null}

            <form autoComplete="off" className={styles.form} onSubmit={onSubmitClick}>
                {invalidUrlError !== '' &&
                    <div className={styles.invalidUrl}>
                        <div className={styles.complionSubTitle} style={{ color: 'red' }}>{invalidUrlError}</div>
                    </div>}
                {!showResetPassword && invalidUrlError === '' &&

                    (<div className={styles.formGroup}>
                        <div className={styles.labelGroup}>
                            <label htmlFor="email" className={styles.inputLabelv4}>
                                Email Address
                            </label>
                        </div>
                        <div className={styles.labelGroup} style={{ marginTop: '10px' }}>
                            <label htmlFor="answer" className={styles.caption}>
                                {registrationEmail}
                            </label>
                        </div>
                        <div className={styles.labelGroup} style={{ marginTop: '10px' }}>
                            <label htmlFor="security-question" className={styles.inputLabelv4}>
                                Security Question
                            </label>
                        </div>

                        <div className={styles.labelGroup}>
                            <div className={styles.selectWrapper}>
                                <select
                                    id="security-question"
                                    value={selectedQuestion}
                                    onChange={handleQuestionChange}
                                    className={styles.outlinedSelect}
                                >
                                    {allChallengeQuestions && allChallengeQuestions.map((question, index) => (
                                        <option key={question.id} value={question.question} className={styles.selectOptions}>
                                            {question.question}
                                        </option>
                                    ))}
                                </select>
                                <FontAwesomeIcon
                                    icon={faChevronDown}
                                    className={`${styles.selectIcon} ${styles.icon}`}
                                />
                            </div>
                        </div>
                        <div className={styles.labelGroup} style={{ marginTop: '10px' }}>
                            <label htmlFor="answer" className={styles.inputLabelv4}>
                                Answer
                            </label>
                        </div>
                        <input
                            id="answer"
                            className={`${styles.inputv4} ${props.resetPasswordAnswerError && styles.inputErrorv4}`}
                            type="answer"
                            name="answer"
                            value={answer}
                            onChange={(e) => setAnswer(e.target.value)}
                            autoFocus
                        />

                        {props.resetPasswordAnswerError && <pre className={styles.errorv4}>{props.resetPasswordAnswerError}</pre>}

                    </div>
                    )}

                {showResetPassword && (
                    <div className={styles.formGroup}>
                        <div className={styles.labelGroup}>
                            <label htmlFor="password" className={styles.inputLabelv4}>
                                New password
                            </label>
                        </div>
                        <div className={`${styles.passowordInput} ${props.resetPasswordValidationError && styles.passowordInputError}`}>
                            <input
                                id="password"
                                className={`${props.resetPasswordValidationError && styles.inputErrorv4}`}
                                type={passwordType ? 'password' : 'text'}
                                name="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <FontAwesomeIcon
                                icon={passwordType ? faEye : faEyeSlash}
                                className={styles.passwordIcon}
                                onClick={togglePasswordVisibility}
                            />
                        </div>
                        {props.resetPasswordValidationError && <span className={styles.errorv4}>{props.resetPasswordValidationError}</span>}
                        <PasswordValidation password={password} setValidPassword={setValidPassword} />
                    </div>

                )}


                {invalidUrlError === '' && <div className={styles.formGroup}>
                    <button type="submit" className={styles.actionButtonv4}>
                        {showResetPassword ? 'Create Password' : 'Next'}
                    </button>
                </div>
                }
            </form>
        </LoginLayout>
    );
};
const mapStateToProps = (state) => ({
    resetPasswordAnswerError: lodash.get(state, 'resetPasswordAnswerError', false),
    resetPasswordValidationError: lodash.get(state, 'resetPasswordValidationError', false)
});

export default connect(mapStateToProps, { setResetPasswordAnswerError, setResetPasswordValidationError })(NewUser);